import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import doctor from "./doctor.module";
import patient from "./patient.module";
import game from "./game.module";
import gameInfo from "./gameInfo.module";

Vue.use(Vuex);
export default function() {
  const Store = new Vuex.Store({
    modules: {
      auth,
      htmlClass,
      config,
      breadcrumbs,
      doctor,
      patient,
      game,
      gameInfo
    },
    plugins: [
      createPersistedState({
        storage: {
          getItem: key => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: key => ls.remove(key)
        }
      })
    ]
  });
  return Store;
}
